/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import DataTable from 'react-data-table-component';
import {
  // Form,
  Input,
  Button,
  Radio,
  DatePicker,
  Checkbox,
  notification
} from "antd";
import butSearch from "../../../assets/icons/icon-but-search.png";
import notiArea from "../../../assets/icons/remove-area.png";
import Cookies from "js-cookie";
import "./custom-antd.css";
import moment from "moment";
import Api from "../../../services/ServiceApi";
import { connect } from "react-redux";
import { changeLang } from "../../../actions/langAction";
import { setDynamic } from "../../../actions/dynamicAction";
import 'moment/locale/th';
// import locale from 'antd/lib/locale/th_TH';

class vendorGroup extends Component {
/** JSON.parse(localStorage.getItem("companyData") */
constructor(props) {
  super(props);
  this.state = {
    factUpdate: false,
    LangTranslate: [[]],
    title: "Vendor",
    isLoadingVendor: true,
    companyDataList: JSON.parse(localStorage.getItem("companyData")),
    vendorCodeAdd: "",
    vendorNameAdd: "",
    vendorAreaDataList: [],
    vendorAreaIDAdd: "",
    contactNameAdd: "",
    emailAdd: "",
    contactNumberAdd: "",
    AddVendorGroupDisplay1: "none",
    AddVendorGroupDisplay2: "none",
    AddVendorGroupDisplay3: "none",
    ConfirmDisplay: "none",
    ConfirmDisplayAddTeam: "none",
    ConfirmDisplayAddVendor: "none",
    dateFormat: "DD/MM/YYYY",
    EffectiveDateAdd: moment().toDate(),
    ExpiryDateAdd: moment().toDate(),

    where: "",
    resultAddNewText: "",
    actionCase: "Add",
    disableChangeValue: false,
    fillEffectiveDateDisplay: "none",

    /* form add team */
    operatorIDAdd: Number(Cookies.get("operator_id")),
    projectIDAdd: Number(Cookies.get("project_id")),
    operatorAdd: [],
    projectDataAdd: [],
    jobCategoryIDAdd: 0,
    teamGroupTypeIDAdd: 0,
    teamGroupNameAdd: "",
    EffectiveDateVendorAdd: moment().toDate(),
    EffectiveDateVendorAddFilter: moment().toDate(),
    ExpiryDateVendorAdd: moment().toDate(),
    statusVendorAdd: 1,

    // EffectiveDateAdd: moment().toDate(),
    EffectiveDateAddFilter: moment().toDate(),
    ExpiryDateAdd: moment().toDate(),
    statusAdd: 1,

    /* form add vendor */
    companyID:  Number(Cookies.get("companyid")),
    companyIDAdd: Number(Cookies.get("companyid")),
    companyIDGetSubAdd: 0,
    vendorTypeAdd: "",
    vendorCodeAdd: "",
    vendorNameAdd: "",
    vendorAddressAdd: "",
    contactNameAdd: "",
    emailAdd: "",
    telephoneAdd: "",
    faxNoAdd: "",
    areaDataList: [],
    vendorAreaIDRowAdd: 0,
    vendorAreaNameRowAdd: "",
    areaIDAdd: 0,
    subAreaDataList: [],
    vendorSubAreaIDRowAdd: 0,
    vendorSubAreaNameRowAdd: "",
    vendorZoneIDRowAdd: 0,
    vendorZoneNameRowAdd: "",
    vendorZoneDataList: [],

    filterDataList: [],

    operatorIDRowAdd: Number(Cookies.get("operator_id")),
    operatorDataRowAdd: [],
    filterProjectdataRowAdd: [],
    projectIDRowAdd: Number(Cookies.get("project_id")),
    projectDataRowAdd: [],

    vendorArea0: <div></div>,
    vendorArea1: <div></div>,
    vendorArea2: <div></div>,
    vendorArea3: <div></div>,
    vendorArea4: <div></div>,
    vendorArea5: <div></div>,
    vendorArea6: <div></div>,
    vendorArea7: <div></div>,
    vendorArea8: <div></div>,
    vendorArea9: <div></div>,
    vendorArea10: <div></div>,
    vendorArea11: <div></div>,
    vendorArea12: <div></div>,
    vendorArea13: <div></div>,
    vendorArea14: <div></div>,
    vendorArea15: <div></div>,
    vendorArea16: <div></div>,
    vendorArea17: <div></div>,
    vendorArea18: <div></div>,
    vendorArea19: <div></div>,
    vendorArea20: <div></div>,
    rowID: 0,

    displayVendor1: "none",
    displayVendor2: "none",
    displayVendor3: "none",
    displayVendor4: "none",
    displayVendor5: "none",
    displayVendor6: "none",
    displayVendor7: "none",
    displayVendor8: "none",
    displayVendor9: "none",
    displayVendor10: "none",
    displayVendor11: "none",
    displayVendor12: "none",
    displayVendor13: "none",
    displayVendor14: "none",
    displayVendor15: "none",
    displayVendor16: "none",
    displayVendor17: "none",
    displayVendor18: "none",
    displayVendor19: "none",
    displayVendor20: "none",

    selectarea0:"checked",
    selectarea1:"checked",
    selectarea2:"checked",
    selectarea3:"checked",
    selectarea4:"checked",
    selectarea5:"checked",
    selectarea6:"checked",
    selectarea7:"checked",
    selectarea8:"checked",
    selectarea9:"checked",
    selectarea10:"checked",
    selectarea11:"checked",
    selectarea12:"checked",
    selectarea13:"checked",
    selectarea14:"checked",
    selectarea15:"checked",
    selectarea16:"checked",
    selectarea17:"checked",
    selectarea18:"checked",
    selectarea19:"checked",
    selectarea20:"checked",

    VendorAreaSelectDataList:[],
    VendorAreaSelectDataListInsert: [],
    VendorAreaSelectDataListEdit: [],

    whereTeam: "",
    TeamGroupDataList: [],
    statusActive: ["Inactive","Active"],
    TeamGroupSelectList: [{teamgrouptype:60},{teamgrouptype:50}],

    categoryDataList: [],
    TeamGroupTypeDataList: [],
    vendorIDAdd: 0,

    VendorTeamGroupDataList: [],

    teamGroup1: <div></div>,
    teamGroup2: <div></div>,
    teamGroup3: <div></div>,
    teamGroup4: <div></div>,
    teamGroup5: <div></div>,
    teamGroup6: <div></div>,
    teamGroup7: <div></div>,
    teamGroup8: <div></div>,
    teamGroup9: <div></div>,
    teamGroup10: <div></div>,
    displayTeamGroup1: "none",
    displayTeamGroup2: "none",
    displayTeamGroup3: "none",
    displayTeamGroup4: "none",
    displayTeamGroup5: "none",
    displayTeamGroup6: "none",
    displayTeamGroup7: "none",
    displayTeamGroup8: "none",
    displayTeamGroup9: "none",
    displayTeamGroup10: "none",
    companyIDTeamGroupAdd: Number(Cookies.get("companyid")),

    vendorAreaEdit: [],
    vendorContactID: 0 , 
    selectArea : []

  };

}

async componentDidMount() {
  Api.post("master_language_detail_get", {
    company_id: Cookies.get("companyid"),
    page_id: 1,
  })
    .then((response) => {
      this.setState({
        LangTranslate: JSON.parse(
          response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
        ),
        factUpdate: true,
      });
    })
    .catch((e) => {
      console.log(e);
    });

    if (
      localStorage.getItem("projectData") === null ||
      localStorage.getItem("projectData") === undefined
    ) {
      this.logoutClicked();
    } else {
      const filterProjectdata = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        //return data.operator_id == Cookies.get("operator_id");
        return data.operator_id == this.state.operatorID;
      });
      this.setState({
        operator: JSON.parse(localStorage.getItem("operator")),
        projectData: filterProjectdata,
      });

      const filterProjectdataAdd = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        //return data.operator_id == Cookies.get("operator_id");
        return data.operator_id == this.state.operatorIDAdd;
      });

      const filterProjectdataRowAdd = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        return data.operator_id == this.state.operatorIDRowAdd;
      });

      this.setState({
        operatorAdd: JSON.parse(localStorage.getItem("operator")),
        projectDataAdd: filterProjectdataAdd,

        operatorDataRowAdd: JSON.parse(localStorage.getItem("operator")),
        projectDataRowAdd: filterProjectdataRowAdd,
      });

    }
    this.loadArea();
    this.loadZone();
    this.loadVendor();
}

notify = (type, title, msg) => {
  const args = {
    message: title,
    description: msg,
    duration: 5,
    className: "font-thai-b",
  };
  notification[type](args);
};

loadVendor(){
  Api.post("master_data/get_vendor", {
    "company_id": this.state.companyID,
    "where" : this.state.where
  })
  .then((res) => {
    const { result, data } = res.data;
    if (result.code === "P") {
      const tmp = [];
      data.result.map((item, index) => (
        tmp.push({
          "vendorCode": item.vendor_code,
          "vendorName": <div title={item.vendor_name}>{item.vendor_name}</div>,
          "vendorAddress": <div title={item.vendor_address}>{item.vendor_address}</div>,
          "serviceCode": (item.sum_service_code == null)? <span className="txt-warning">0 Service Code</span>: <span>{item.sum_service_code + " Service Code"}</span>,
          "effectiveDate": this.displayDate(item.effective_date),
          "expiredDate": this.displayDate(item.expire_date),
          "Option":<button onClick={()=> this.clickEdit(item.company_id,item.operator_id,item.project_id,item.vendor_id,item.vendor_code,item.vat,item.vendor_name,item.vendor_address,item.contact_person,item.tel_no,item.fax_no,item.list_email,item.effective_date,item.expire_date,item.is_active)} id={"btnEdit"+index} className="text-primary">View</button>
        })
      ))
      this.setState({filterDataList: tmp, isLoadingVendor: false})
    }//
  })
  .catch((e) => {
    console.log("error add new vendor team group", e);
  })

}

clickEdit(company_id, operator_id, project_id, vendor_id, vendor_code, vendor_type, vendor_name, vendor_address, contact_person, tel_no, fax_no, list_email,effective_date,expire_date,is_active ){
  this.state.actionCase = "Edit";
  this.state.vendorIDAdd = vendor_id;
  this.state.VendorAreaSelectDataListEdit = [];

  const filterOperatordataRowAdd = JSON.parse(
    localStorage.getItem("operator")
  ).filter((data) => {
    return data.company_id == company_id;
  });

  const filterProjectdataRowAdd = JSON.parse(
    localStorage.getItem("projectData")
  ).filter((data) => {
    return data.operator_id == operator_id;
  });

  Api.post("master_data/get_data_by_vendor", {
    "company_id": company_id,
    "vendor_id" : vendor_id,
    "where" : ""
  })
  .then((res) => {
    const { result, data } = res.data;
    if (result.code === "P") {
      const tmp = [];
      (data.result.map(item =>(
        tmp.push({
          "vendor_area_id" : item.vendor_area_id,
            "area_id" : item.area_id,
            "area_code" : item.area_code,
            "sub_area_id" : item.sub_area_id,
            "sub_area_code" : item.sub_area_code,
            "zone_id" : item.zone_id,
            "zone_code" : item.zone_code,
            "delete_flag" : null,
            "vendor_contact_id" : item.vendor_contact_id
          })
      )))
      this.setState({ VendorAreaSelectDataListEdit: tmp, vendorContactID: tmp.vendor_contact_id}, ()=> {
        console.log('click edit show list area set = ', this.state.VendorAreaSelectDataListEdit)
      });
      tmp = [];
    }
  })
  .catch((e) => {
    console.log("error add new vendor team group", e);
  })

  Api.post("master_data/get_area_name", {
    "company_id" : company_id
  })
  .then((res) => {
    const { result, data } = res.data;
    if (result.value === "P") {
      this.setState({ areaDataList: data.result})
    }
  })
  .catch((e) => {
    console.log(e);
  });

  Api.post("master_data/get_zone_name", {

    "company_id" : company_id,
    "operator_id" : operator_id,
    "project_id" : project_id
  })
  .then((res) => {
    const { result, data } = res.data;
    if (result.value === "P") {
      this.setState({ vendorZoneDataList: data.result})
    }
  })
  .catch((e) => {
    console.log(e);
  });

  this.setState({companyIDAdd: company_id, vendorCodeAdd: vendor_code, vendorTypeAdd: vendor_type, vendorNameAdd: vendor_name, vendorAddressAdd: vendor_address, contactNameAdd: contact_person, telephoneAdd: tel_no, faxNoAdd: fax_no, emailAdd: list_email, EffectiveDateVendorAdd:(effective_date != null)? this.displayDate(effective_date): "", EffectiveDateVendorAddFilter: (effective_date != null)? this.displayDate(effective_date): "",ExpiryDateVendorAdd: (expire_date != null)? this.displayDate(expire_date) : "", statusVendorAdd: is_active, AddVendorGroupDisplay1: "block",operatorDataRowAdd: filterOperatordataRowAdd,
  operatorIDRowAdd: 0, projectDataRowAdd: filterProjectdataRowAdd, projectIDRowAdd: 0});

}

setSearchText = (event) => {
  this.setState({
    where: event.target.value
  })
}

setSearchTextTeam = (event) => {
  this.setState({
    whereTeam: event.target.value
  })
}

onAddVendorGroup = () => {
  window.scrollTo(0, 0);
  if(this.state.AddVendorGroupDisplay1 == "none"){
    this.setState({
      AddVendorGroupDisplay1: "block"
    })
  }else{
    this.setState({
      AddVendorGroupDisplay1: "none"
    })
  }
}

onCallConfirmWindow = () => {
  if(this.state.ConfirmDisplay == "none"){
    this.setState({ConfirmDisplay: "block"});
  }else{
    this.setState({ConfirmDisplay: "none"})
  }
}

onResetFormAddNew = () => {
  this.onCallConfirmWindow();
  this.onCloseAddNewWindow();
  this.onAddProblemType();
}

onCloseAddNewWindow = () => {
  this.setState({
    vendorCodeAdd: "",
    vendorNameAdd: "",
    vendorAddressAdd: "",
    vendorAreaAdd: "",
    contactNameAdd: "",
    telephoneAdd: "",
    faxNoAdd: "",
    emailAdd: "",
    contactNumberAdd: "",
    EffectiveDateVendorAdd: moment().toDate(),
    ExpiryDateVendorAdd: moment().toDate(),
    EffectiveDateAddFilter: moment().toDate(),
    EffectiveDateVendorAddFilter: moment().toDate(),
    AddVendorGroupDisplay1: "none",
    actionCase: "Add",
    vendorArea0: <div></div>,
    vendorArea1: <div></div>,
    vendorArea2: <div></div>,
    vendorArea3: <div></div>,
    vendorArea4: <div></div>,
    vendorArea5: <div></div>,
    vendorArea6: <div></div>,
    vendorArea7: <div></div>,
    vendorArea8: <div></div>,
    vendorArea9: <div></div>,
    vendorArea10: <div></div>,
    vendorArea11: <div></div>,
    vendorArea12: <div></div>,
    vendorArea13: <div></div>,
    vendorArea14: <div></div>,
    vendorArea15: <div></div>,
    vendorArea16: <div></div>,
    vendorArea17: <div></div>,
    vendorArea18: <div></div>,
    vendorArea19: <div></div>,
    vendorArea20: <div></div>,
    rowID: 0,
    displayVendor1: "none",
    displayVendor2: "none",
    displayVendor3: "none",
    displayVendor4: "none",
    displayVendor5: "none",
    displayVendor6: "none",
    displayVendor7: "none",
    displayVendor8: "none",
    displayVendor9: "none",
    displayVendor10: "none",
    displayVendor11: "none",
    displayVendor12: "none",
    displayVendor13: "none",
    displayVendor14: "none",
    displayVendor15: "none",
    displayVendor16: "none",
    displayVendor17: "none",
    displayVendor18: "none",
    displayVendor19: "none",
    displayVendor20: "none",
    VendorAreaSelectDataListEdit: [],
    VendorAreaSelectDataListInsert: [],
    VendorAreaSelectDataListEditUpdate: []
  })
}

displayDate  = (data) => {
  if(data != null){
    const day = data.substring(0,10).split("-");
    return day[2] + "/" + day[1] + "/" + day[0];
  }
  return "-";
}

onCallConfirmWindowAndCallAddNewAgain = () => {
  this.onCallConfirmWindow();
  this.onAddVendorGroup();
}

ClickAction1 = (e) => {
  window.scrollTo(0, 0);

  e.preventDefault();
  if(this.state.vendorTypeAdd == ""){
    this.notify("info", "Informaton", "Please select vendor type before.");
  }else{

    if(this.state.actionCase == "Add"){
      if(this.state.VendorAreaSelectDataListInsert.length == 0){
        this.notify("info", "Informaton", "Please select check Area under area, sub area, zone before.");
        e.stopPropagation();
      }else{
        if(this.state.EffectiveDateVendorAdd == ""){
          this.setState({fillEffectiveDateDisplay:"block"});
        }else{

          this.setState({fillEffectiveDateDisplay:"none"});

            Api.post("master_data/insert_vendor", {
              "company_id" : this.state.companyIDAdd,
              "vendor_code" : this.state.vendorCodeAdd,
              "vendor_type" : this.state.vendorTypeAdd,
              "vendor_name" : this.state.vendorNameAdd,
              "vendor_address" : this.state.vendorAddressAdd,
              "tel_no" : this.state.telephoneAdd,
              "fax_no" : this.state.faxNoAdd,
              "contact_person" : this.state.contactNameAdd,
              "is_active" : this.state.statusVendorAdd,
              "create_by" : Cookies.get("userId"),
              "effective_date" : moment(this.state.EffectiveDateVendorAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
              "expire_date" : (this.state.ExpiryDateVendorAdd != '') ? moment(this.state.ExpiryDateVendorAdd,"DD/MM/YYYY").format("YYYY-MM-DD"): null,
              "email_address" : this.state.emailAdd,
              "TokenUser" : Cookies.get(`OperationToken`),
              "vendorarealist": this.state.VendorAreaSelectDataListInsert
          })
            .then((res) => {
              console.log('Action: Add');
              const { result, data } = res.data;
              if (result.code === "P") {
                this.setState({AddVendorGroupDisplay1: "none", vendorIDAdd: result.value,fillEffectiveDateDisplay:"none"})
                this.displayPage2();
              }else{
                this.setState({AddVendorGroupDisplay1 : "none", ConfirmDisplayAddVendor:"block"})
              }
              if(result.showText == "Success"){
                this.setState({resultAddNewText:"เพิ่มข้อมูลเสร็จสิ้น"});
              }else{
                this.setState({resultAddNewText:result.showText});
              }

            })
            .catch((e) => {
              console.log("error add new problem type", e);
            })

        }
      }
    }else{
      console.log('on click submit edit vendor ='+this.state.VendorAreaSelectDataListEdit.length)
      if(this.state.VendorAreaSelectDataListEdit.length == 0){
        this.notify("info", "Informaton", "Please select check Area under area, sub area, zone before.");
        e.stopPropagation();
      }else{
        if(this.state.EffectiveDateVendorAdd == ""){
          this.setState({fillEffectiveDateDisplay:"block"});
        }else{
          this.setState({fillEffectiveDateDisplay:"none"});
          this.editData(e);
        }
      }
    }
  }
  e.stopPropagation();
}

editData = (e) => {
  console.log('Action: Edit');
  window.scrollTo(0, 0);
  e.preventDefault();
  if(this.state.vendorTypeAdd == ""){
    this.notify("info", "Informaton", "Please select vendor type before.");
  }else{
    if(this.state.EffectiveDateAdd == ""){
      this.setState({fillEffectiveDateDisplay:"block"});
    }else{
      this.setState({fillEffectiveDateDisplay:"none"});
      console.log('company_id = '+this.state.companyIDAdd);
      /** statement save data */
      Api.post("master_data/update_vendor", {
        "company_id" : this.state.companyIDAdd,
        "vendor_id" : this.state.vendorIDAdd,
        "vendor_code" : this.state.vendorCodeAdd,
        "vendor_type" : this.state.vendorTypeAdd,
        "vendor_name" : this.state.vendorNameAdd,
        "vendor_address" : this.state.vendorAddressAdd,
        "tel_no" : this.state.telephoneAdd,
        "fax_no" : this.state.faxNoAdd,
        "vendor_contact_id": this.state.vendorContactID,
        "contact_person" : this.state.contactNameAdd,
        "is_active" : this.state.statusVendorAdd,
        "update_by": Cookies.get("userId"),
        "effective_date" : moment(this.state.EffectiveDateVendorAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
        "expire_date" : (this.state.ExpiryDateVendorAdd != '')? moment(this.state.ExpiryDateVendorAdd,"DD/MM/YYYY").format("YYYY-MM-DD"):"",
        "email_address" : this.state.emailAdd,
        "TokenUser" : Cookies.get(`OperationToken`),
        "vendorarealist": this.state.VendorAreaSelectDataListEdit
      })
        .then((res) => {
          const { result, data } = res.data;
          if (result.code === "P") {
            this.setState({AddVendorGroupDisplay1 : "none", companyID: this.state.companyIDAdd})
            this.loadVendor();
            this.displayPage2();
          }else{
            this.setState({AddVendorGroupDisplay1 : "none", ConfirmDisplayAddVendor:"block"})
          }
          if(result.showText == "Success"){
            this.setState({resultAddNewText:"แก้ไขข้อมูลเสร็จสิ้น"});
          }else{
            this.setState({resultAddNewText:result.showText});
          }
        })
        .catch((e) => {
          console.log("error editing vendor", e);
        })

    }
  }
  e.stopPropagation();
}

ClickAction2 = (e) => {
  window.scrollTo(0, 0);

  e.preventDefault();

  Api.post("master_data/insert_vendor_to_teamgroup",
      this.state.VendorTeamGroupDataList
  )
    .then((res) => {
      console.log('Action: Add team group in vendor');
      const { result, data } = res.data;
      if (result.code === "P") {
        this.setState({ConfirmDisplay: "block"})
      }
      if(result.showText == "Success"){
        this.setState({resultAddNewText:"เพิ่มข้อมูลเสร็จสิ้น"});
      }else{
        this.setState({resultAddNewText:result.showText});
      }

    })
    .catch((e) => {
      console.log("error add new vendor team group", e);
    })
 
  e.stopPropagation();
}

ClickAction3 = (e) => {
  window.scrollTo(0, 0);

  e.preventDefault();
  if(this.state.EffectiveDateAdd == ""){
    this.setState({fillEffectiveDateDisplay:"block"});
  }else{
    this.setState({fillEffectiveDateDisplay:"none"});
    Api.post("master_data/insert_team_group_n_vendor", {
      "company_id" : this.state.companyIDTeamGroupAdd,
      "operator_id" : this.state.operatorIDAdd,
      "project_id" : this.state.projectIDAdd,
      "team_group_name" : this.state.teamGroupNameAdd,
      "vendor_id" : this.state.vendorIDAdd,
      "group_type_id" : this.state.teamGroupTypeIDAdd,
      "team_group_duty_code" : "O",
      "job_category_id" : this.state.jobCategoryIDAdd,
      "is_active" : this.state.statusAdd,
      "effective_date" : moment(this.state.EffectiveDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"),
      "expire_date" : (this.state.ExpiryDateAdd != '') ? moment(this.state.ExpiryDateAdd,"DD/MM/YYYY").format("YYYY-MM-DD"): null,
      "create_by" : Cookies.get("userId")
    })
    .then((res) => {
      console.log('Action: Add team group');
      const { result, data } = res.data;
      if (result.code === "P") {
        this.setState({AddVendorGroupDisplay3 : "none",ConfirmDisplayAddTeam: "block"})
      }
      if(result.showText == "Success"){
        this.setState({resultAddNewText:"เพิ่มข้อมูลเสร็จสิ้น"});
      }else{
        this.setState({resultAddNewText:result.showText,ConfirmDisplayAddTeam: "block"});
      }

    })
    .catch((e) => {
      console.log("error add new vendor team group", e);
    })

  }

  e.stopPropagation();
}
/*8888888888888888888888888888*/
setVendorCodeAdd = (event) => {
  this.setState({vendorCodeAdd: event.target.value})
}

setVendorNameAdd = (event) => {
  this.setState({vendorNameAdd: event.target.value})
}

setVendorAddressAdd = (event) => {
  this.setState({vendorAddressAdd: event.target.value})
}
setVendorAreaAdd = (event) => {
  this.setState({vendorAreaIDAdd: event.target.value})
}

setContactNameAdd = (event) => {
  this.setState({contactNameAdd: event.target.value})
}

setEmailAdd = (event) => {
  this.setState({emailAdd: event.target.value})
}

setContactNumberAdd = (event) => {
  this.setState({contactNumberAdd: event.target.value})
}

setTelephoneAdd = (event) => {
  this.setState({telephoneAdd: event.target.value})
}

setFaxNoAdd = (event) => {
  this.setState({faxNoAdd: event.target.value})
}

setCompany = (event) => {
  this.setState({companyID: event.target.value});
}

setCompanyAdd = (event) => {
  this.state.companyIDAdd = event.target.value;
  console.log('company id:'+this.state.companyIDAdd);

  const filterOperatordataAdd = JSON.parse(
    localStorage.getItem("operator")
  ).filter((data) => {
    return data.company_id == event.target.value;
  });
  console.log('filterOperatordataAdd:',filterOperatordataAdd )

  this.setState({
    operatorIDRowAdd: 0,
    operatorDataRowAdd: filterOperatordataAdd,
    projectIDRowAdd: 0,
    projectDataRowAdd: [],
    vendorZoneIDRowAdd: 0,
    vendorZoneNameRowAdd: "",
    vendorZoneDataList:[]
  })
}

setOperatorAdd = (event) => {
  this.setState({
    teamIDAdd: 0,
    operatorIDAdd: event.target.value
  });

  const filterProjectdataAdd = JSON.parse(
    localStorage.getItem("projectData")
  ).filter((data) => {
    return data.operator_id == event.target.value;
  });

  this.setState({
    projectIDAdd: "",
    projectDataAdd: filterProjectdataAdd,
  })
}

setOperatorRowAdd = (event) => {
  this.setState({
    operatorIDRowAdd: event.target.value
  });

  const filterProjectdataRowAdd = JSON.parse(
    localStorage.getItem("projectData")
  ).filter((data) => {
    return data.operator_id == event.target.value;
  });

  this.setState({
    projectIDRowAdd: "",
    projectDataRowAdd: filterProjectdataRowAdd,
  })
}

setProjectDataAdd = (event) => {
  this.state.projectIDAdd = event.target.value;
  this.loadCategory();
  this.loadTeamGroupType();
}

setProjectRowDataAdd = (event) => {
  this.setState({projectIDRowAdd :event.target.value});
}

setJobCategoryAdd = (event) => {
  this.setState({jobCategoryIDAdd: event.target.value});
}

setTeamGroupType = (event) => {
  this.setState({teamGroupTypeIDAdd: event.target.value});
}

setTeamGroupName = (event) => {
  this.setState({teamGroupNameAdd: event.target.value});
}

setStatus = (event) => {
  this.setState({
    statusAdd: event.target.value
  })
}

setStatusVendor = (event) => {
  this.setState({
    statusVendorAdd: event.target.value
  })
}

setAreaRowAdd = (companyid,event) => {
  var val = event.target.value;
  var obj = val.split("_");

  this.setState({
    vendorAreaIDRowAdd: obj[0],
    vendorAreaNameRowAdd: obj[1]
  })
  Api.post("master_data/get_sub_area_name", {
    "company_id" : companyid,
    "job_area_id" : obj[0]
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({ subAreaDataList: data.result})
      }
    })
    .catch((e) => {
      console.log(e);
    });
}

setVendorSubAreaRowAdd = (event) => {
  var val = event.target.value;
  var obj = val.split("_");
  this.setState({
    vendorSubAreaIDRowAdd: obj[0],
    vendorSubAreaNameRowAdd: obj[1]
  })
}

setVendorZoneRowAdd = (event) => {
  var val = event.target.value;
  var obj = val.split("_");
  this.setState({
    vendorZoneIDRowAdd: obj[0],
    vendorZoneNameRowAdd: obj[1]
  })
}

onChangeEffectiveDate = (date, dateString) =>{
  this.setState({
    EffectiveDateAdd: dateString,
    EffectiveDateAddFilter: moment(dateString,"DD/MM/YYYY")
  })
}

onChangeExpiryDate = (date, dateString) => {
  this.setState({
    ExpiryDateAdd: dateString
  })
}

onChangeEffectiveDateVendor = (date, dateString) =>{
  this.setState({
    EffectiveDateVendorAdd: dateString,
    EffectiveDateVendorAddFilter: moment(dateString,"DD/MM/YYYY")
  })
}

onChangeExpiryDateVendor = (date, dateString) => {
  this.setState({
    ExpiryDateVendorAdd: dateString
  })
}

displayPage3(){
  this.setState({AddVendorGroupDisplay3:"block",AddVendorGroupDisplay2:"none"});
  this.loadCategory();
  this.loadTeamGroupType();
}

onCloseAddNewTeamWindow(){
  window.scrollTo(0,0);
  this.setState({AddVendorGroupDisplay2:"block",AddVendorGroupDisplay3:"none"})
}

loadArea = () => {
  console.log('company_id loadArea'+this.state.companyIDAdd);
  Api.post("master_data/get_area_name", {
    "company_id" : this.state.companyIDAdd
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({ areaDataList: data.result})
      }
    })
    .catch((e) => {
      console.log(e);
    });
}

loadSubArea = () => {
  console.log('dd:'+this.state.companyIDGetSubAdd);

  Api.post("master_data/get_sub_area_name", {
    company_id : this.state.companyIDAdd,
    job_area_id : this.state.vendorAreaIDRowAdd
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({ subAreaDataList: data.result})
      }
    })
    .catch((e) => {
      console.log(e);
    });
}

loadZone = () => {
  this.setState({vendorZoneDataList:[]});
  Api.post("master_data/get_zone_name", {

      "company_id" : this.state.companyIDAdd,
      "operator_id" : this.state.operatorIDRowAdd,
      "project_id" : this.state.projectIDRowAdd
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({ vendorZoneDataList: data.result})
      }
    })
    .catch((e) => {
      console.log(e);
    });
}

setProjectRowDataAdd = (event) => {
  this.setState({projectIDRowAdd: event.target.value});

  Api.post("master_data/get_zone_name", {
    company_id : this.state.companyIDAdd,
    operator_id : this.state.operatorIDRowAdd,
    project_id : event.target.value
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({vendorZoneDataList: data.result, vendorZoneIDRowAdd: 0})
      }
    })
    .catch((e) => {
      console.log(e);
    });

}

removeRow(row){
  var myClasses = document.querySelectorAll('.row-vendor-area-'+row),
    i = 0,
    l = myClasses.length;
  myClasses[0].style.display = 'none';

  if(row == 0){
    this.state.displayVendor0 = "none";
    console.log('display row0 '+ row + ' = '+this.state.displayVendor0)
  } else if(row == 1){
    this.state.displayVendor1 = "none";
    console.log('display row1 '+ row + ' = '+this.state.displayVendor1)
  }
}

setAreaEdit = (val,event) => {
  var data = this.state.VendorAreaSelectDataListEdit;
  var data_tmp = [];
  var tmp = val.split("_");
  var area_id = tmp[0];
  var sub_area_id = tmp[1];
  var zone_id = tmp[2];

  if(event.target.checked == true){
    data.map((item) => (
      ((item.area_id == area_id) && (item.sub_area_id == sub_area_id) && (item.zone_id == zone_id))?
        data_tmp.push(
          {
            "vendor_area_id" : item.vendor_area_id,
            "area_id" : item.area_id,
            "area_code" : item.area_code,
            "sub_area_id" : item.sub_area_id,
            "sub_area_code" : item.sub_area_code,
            "zone_id" : item.zone_id,
            "zone_code" : item.zone_code,
            "delete_flag" : null
          }
        )
      :
      (
        data_tmp.push(
          {
            "vendor_area_id" : item.vendor_area_id,
            "area_id" : item.area_id,
            "area_code" : item.area_code,
            "sub_area_id" : item.sub_area_id,
            "sub_area_code" : item.sub_area_code,
            "zone_id" : item.zone_id,
            "zone_code" : item.zone_code,
            "delete_flag" : item.delete_flag
          }
        )
      )
    ))
  } else {
    data.map((item) => (
      ((item.area_id == area_id) && (item.sub_area_id == sub_area_id) && (item.zone_id == zone_id) && (item.vendor_area_id != null))?
        data_tmp.push(
          {
            "vendor_area_id" : item.vendor_area_id,
            "area_id" : item.area_id,
            "area_code" : item.area_code,
            "sub_area_id" : item.sub_area_id,
            "sub_area_code" : item.sub_area_code,
            "zone_id" : item.zone_id,
            "zone_code" : item.zone_code,
            "delete_flag" : 1
          }
        )
      :
        ((item.area_id == area_id) && (item.sub_area_id == sub_area_id) && (item.zone_id == zone_id) && (item.vendor_area_id == null))?
          null
        :
          data_tmp.push(
            {
              "vendor_area_id" : item.vendor_area_id,
              "area_id" : item.area_id,
              "area_code" : item.area_code,
              "sub_area_id" : item.sub_area_id,
              "sub_area_code" : item.sub_area_code,
              "zone_id" : item.zone_id,
              "zone_code" : item.zone_code,
              "delete_flag" : item.delete_flag
            }
          )
    ))
  }
  this.setState({VendorAreaSelectDataListEdit: data_tmp});
}

setAreaAdd = (val,event) => {
  var data = this.state.VendorAreaSelectDataListInsert;
  var data_tmp = [];
  var tmp = val.split("_");
  var area = tmp[0];
  var subarea = tmp[1];
  var zone = tmp[2];

  if(event.target.checked == true){
    data.map((item) => (
      ((item.area_id == area) && (item.sub_area_id == subarea) && (item.zone_id == zone))?
        null
      :
      (
        data_tmp = [...data_tmp,{
          "area_id" : area,
          "sub_area_id" : subarea,
          "zone_id" : zone,
        }]
      )
    ))
    if(data_tmp.length == this.state.VendorAreaSelectDataListInsert.length){
      this.state.VendorAreaSelectDataListInsert = [...this.state.VendorAreaSelectDataListInsert,{
        "area_id" : area,
        "sub_area_id" : subarea,
        "zone_id" : zone
      }]
    }
  } else {
    var tmp_array = [];
    data.map((item) => (
      ((item.area_id == area) && (item.sub_area_id == subarea) && (item.zone_id == zone))?
        null
      : (
        tmp_array = [...tmp_array,{
          "area_id" : item.area_id,
          "sub_area_id" : item.sub_area_id,
          "zone_id" : item.zone_id,
        }]
      )
    ))
    this.state.VendorAreaSelectDataListInsert = tmp_array;
  }
}

onAddEditAreaRow(row) {// เพิ่ม area ใหม่ case Edit
  console.log('row+ ='+row);

  if((this.state.vendorAreaIDRowAdd > 0) && (this.state.vendorSubAreaIDRowAdd > 0) && (this.state.vendorZoneIDRowAdd > 0)) {

    /*
    tmp.push(
            {
            "vendor_area_id" : item.vendor_area_id,
            "area_id" : item.area_id,
            "area_code" : item.area_code,
            "sub_area_id" : item.sub_area_id,
            "sub_area_code" : item.sub_area_code,
            "zone_id" : item.zone_id,
            "zone_code" : item.zone_code,
            "delete_flag" : item.delete_flag
          }
    )*/
          //add new

          console.log("=================");
          console.log(this.state.VendorAreaSelectDataListEdit);
          console.log("=================");
          this.setState({
            VendorAreaSelectDataListEdit: [...this.state.VendorAreaSelectDataListEdit,  {
              "area_id" : this.state.vendorAreaIDRowAdd,
              "sub_area_id" : this.state.vendorSubAreaIDRowAdd,
              "zone_id" : this.state.vendorZoneIDRowAdd,
            }]  
          })
          console.log("=================");
          console.log(this.state.VendorAreaSelectDataListEdit);
          console.log("=================");

    var val = this.state.vendorAreaIDRowAdd + '_' + this.state.vendorSubAreaIDRowAdd + '_' + this.state.vendorZoneIDRowAdd;
    if(row == 0){
      this.setState({displayVendor0: "block", rowID: this.state.rowID + 1, vendorArea0: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 1){
      this.setState({displayVendor1: "block", rowID: this.state.rowID + 1, vendorArea1: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 2){
      this.setState({displayVendor2: "block", rowID: this.state.rowID + 1, vendorArea2: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 3){
      this.setState({displayVendor3: "block", rowID: this.state.rowID + 1, vendorArea3: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 4){
      this.setState({displayVendor4: "block", rowID: this.state.rowID + 1, vendorArea4: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 5){
      this.setState({displayVendor5: "block", rowID: this.state.rowID + 1, vendorArea5: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 6){
      this.setState({displayVendor6: "block", rowID: this.state.rowID + 1, vendorArea6: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 7){
      this.setState({displayVendor7: "block", rowID: this.state.rowID + 1, vendorArea7: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 8){
      this.setState({displayVendor8: "block", rowID: this.state.rowID + 1, vendorArea8: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 9){
      this.setState({displayVendor9: "block", rowID: this.state.rowID + 1, vendorArea9: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 10){
      this.setState({displayVendor10: "block", rowID: this.state.rowID + 1, vendorArea10: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 11){
      this.setState({displayVendor11: "block", rowID: this.state.rowID + 1, vendorArea11: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 12){
      this.setState({displayVendor12: "block", rowID: this.state.rowID + 1, vendorArea12: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 13){
      this.setState({displayVendor13: "block", rowID: this.state.rowID + 1, vendorArea13: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 14){
      this.setState({displayVendor14: "block", rowID: this.state.rowID + 1, vendorArea14: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 15){
      this.setState({displayVendor15: "block", rowID: this.state.rowID + 1, vendorArea15: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 16){
      this.setState({displayVendor16: "block", rowID: this.state.rowID + 1, vendorArea16: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 17){
      this.setState({displayVendor17: "block", rowID: this.state.rowID + 1, vendorArea17: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 18){
      this.setState({displayVendor18: "block", rowID: this.state.rowID + 1, vendorArea18: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 19){
      this.setState({displayVendor19: "block", rowID: this.state.rowID + 1, vendorArea19: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 20){
      this.setState({displayVendor20: "block", rowID: this.state.rowID + 1, vendorArea20: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    }


    /*
    console.log('v ='+this.state.VendorAreaSelectDataListEdit.length + ' tmp = '+tmp.length);
    if(this.state.VendorAreaSelectDataListEdit.length == tmp.length){
      tmp.push(
        {
            "vendor_area_id" : null,
            "area_id" : this.state.vendorAreaIDRowAdd,
            "area_code" : this.state.vendorAreaNameRowAdd,
            "sub_area_id" : this.state.vendorSubAreaIDRowAdd,
            "sub_area_code" : this.state.vendorSubAreaNameRowAdd,
            "zone_id" : this.state.vendorZoneIDRowAdd,
            "zone_code" : this.state.vendorZoneNameRowAdd,
            "delete_flag" : null
          }
      );
      this.setState({VendorAreaSelectDataListEdit: tmp}, ()=> {
        console.log('area = ', this.state.VendorAreaSelectDataListEdit)
      })
    }
    */

  }

}

onAddAreaRow (row) {
  console.log('row+ ='+row);
  if((this.state.vendorAreaIDRowAdd > 0) && (this.state.vendorSubAreaIDRowAdd > 0) && (this.state.vendorZoneIDRowAdd > 0)) {

    this.state.VendorAreaSelectDataListInsert = [...this.state.VendorAreaSelectDataListInsert, 
        {
          "area_id" : this.state.vendorAreaIDRowAdd,
          "sub_area_id" : this.state.vendorSubAreaIDRowAdd,
          "zone_id" : this.state.vendorZoneIDRowAdd,
        }
    ];

    var val = this.state.vendorAreaIDRowAdd + '_' + this.state.vendorSubAreaIDRowAdd + '_' + this.state.vendorZoneIDRowAdd;
    if(row == 0){
      this.setState({displayVendor0: "block", rowID: this.state.rowID + 1, vendorArea0: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 1){
      this.setState({displayVendor1: "block", rowID: this.state.rowID + 1, vendorArea1: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 2){
      this.setState({displayVendor2: "block", rowID: this.state.rowID + 1, vendorArea2: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 3){
      this.setState({displayVendor3: "block", rowID: this.state.rowID + 1, vendorArea3: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 4){
      this.setState({displayVendor4: "block", rowID: this.state.rowID + 1, vendorArea4: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 5){
      this.setState({displayVendor5: "block", rowID: this.state.rowID + 1, vendorArea5: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 6){
      this.setState({displayVendor6: "block", rowID: this.state.rowID + 1, vendorArea6: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 7){
      this.setState({displayVendor7: "block", rowID: this.state.rowID + 1, vendorArea7: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 8){
      this.setState({displayVendor8: "block", rowID: this.state.rowID + 1, vendorArea8: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 9){
      this.setState({displayVendor9: "block", rowID: this.state.rowID + 1, vendorArea9: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 10){
      this.setState({displayVendor10: "block", rowID: this.state.rowID + 1, vendorArea10: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 11){
      this.setState({displayVendor11: "block", rowID: this.state.rowID + 1, vendorArea11: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 12){
      this.setState({displayVendor12: "block", rowID: this.state.rowID + 1, vendorArea12: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 13){
      this.setState({displayVendor13: "block", rowID: this.state.rowID + 1, vendorArea13: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 14){
      this.setState({displayVendor14: "block", rowID: this.state.rowID + 1, vendorArea14: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 15){
      this.setState({displayVendor15: "block", rowID: this.state.rowID + 1, vendorArea15: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 16){
      this.setState({displayVendor16: "block", rowID: this.state.rowID + 1, vendorArea16: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 17){
      this.setState({displayVendor17: "block", rowID: this.state.rowID + 1, vendorArea17: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 18){
      this.setState({displayVendor18: "block", rowID: this.state.rowID + 1, vendorArea18: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 19){
      this.setState({displayVendor19: "block", rowID: this.state.rowID + 1, vendorArea19: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    } else if(row == 20){
      this.setState({displayVendor20: "block", rowID: this.state.rowID + 1, vendorArea20: <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}}><div style={{width:"120px"}}><input type='Checkbox' onChange={(e)=>this.setAreaAdd(val,e)} /> <span>{this.state.vendorAreaNameRowAdd}</span></div><div style={{width:"120px"}}>{this.state.vendorSubAreaNameRowAdd}</div><div style={{width:"120px"}}>{this.state.vendorZoneNameRowAdd}</div></div>});
    }
  }

}

displayPage2(){
  window.scrollTo(0, 0);
  this.setState({AddVendorGroupDisplay2: "block", AddVendorGroupDisplay1: "none"})
  this.loadTeamGroup();
}

backPage(){
  window.scrollTo(0, 0);
  this.setState({AddVendorGroupDisplay2: "none", AddVendorGroupDisplay1: "block"})
}

loadTeamGroup = () => {
  this.setState({TeamGroupDataList:[]});
  console.log("companyid:"+this.state.companyIDAdd+ " operation_id: "+ this.state.operatorIDRowAdd +
  "projectid: "+this.state.projectIDRowAdd+ " where: "+this.state.whereTeam);
  Api.post("master_data/get_team_group_no_vendor", {
      "company_id" : this.state.companyIDAdd,
      "operator_id" : this.state.operatorIDRowAdd,
      "project_id" : this.state.projectIDRowAdd,
      "team_group_duty_code" : "O",
      "where" : this.state.whereTeam
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({ TeamGroupDataList: data.result})
      }
    })
    .catch((e) => {
      console.log(e);
    });
}

setTeamGroup (event,teamgrouptype,grouptype) {
  var data = this.state.VendorTeamGroupDataList;
  var data_tmp = [];
  if(event.target.checked == true){
    data.map((item) => (
      ((item.team_group_id == teamgrouptype) && (item.group_type_id == grouptype))?
        null
      :
      (
        data_tmp = [...data_tmp,{
          "company_id" : this.state.companyIDAdd,
          "operator_id" : this.state.operatorIDRowAdd,
          "project_id" : this.state.projectIDRowAdd,
          "team_group_id" : this.state.teamgrouptype,
          "group_type_id" : this.state.grouptype,
          "vendor_id" : this.state.vendorIDAdd,
          "update_by" : Cookies.get("userId")
        }]
      )
    ))
    if(data_tmp.length == this.state.VendorTeamGroupDataList.length){
      this.state.VendorTeamGroupDataList = [...this.state.VendorTeamGroupDataList,{
        "company_id" : this.state.companyIDAdd,
        "operator_id" : this.state.operatorIDRowAdd,
        "project_id" : this.state.projectIDRowAdd,
        "team_group_id" : this.state.teamgrouptype,
        "group_type_id" : this.state.grouptype,
        "vendor_id" : this.state.vendorIDAdd,
        "update_by" : Cookies.get("userId")
      }]
    }
    console.log('team group add list',this.state.VendorTeamGroupDataList)
  }else{
    //this.handleRemove({teamgrouptype});
    var tmp_array = [];
    data.map((item) => (
      ((item.team_group_id == teamgrouptype) && (item.group_type_id == grouptype))?
        null
      : (
        tmp_array = [...tmp_array,{
          "company_id" : item.company_id,
          "operator_id" : item.operator_id,
          "project_id" : item.project_id,
          "team_group_id" : item.team_group_id,
          "group_type_id" : item.group_type_id,
          "vendor_id" : item.vendor_id,
          "update_by" : item.update_by
        }]
      )
    ))
    this.state.VendorTeamGroupDataList = tmp_array;
    console.log('team group add list',this.state.VendorTeamGroupDataList)
  }
}

loadCategory = () => {
  Api.post("master_data/get_job_category", {
    "company_id" : this.state.companyIDTeamGroupAdd,
    "operator_id" : this.state.operatorIDAdd,
    "project_id" : this.state.projectIDAdd
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({ categoryDataList: data.result})
      }
    })
    .catch((e) => {
      console.log(e);
    });
}

loadTeamGroupType = () => {
  Api.post("master_data/get_team_group_type", {
    "company_id" : this.state.companyIDTeamGroupAdd,
    "operator_id" : this.state.operatorIDAdd,
    "project_id" : this.state.projectIDAdd
  })
    .then((res) => {
      const { result, data } = res.data;
      if (result.value === "P") {
        this.setState({ TeamGroupTypeDataList: data.result})
      }
    })
    .catch((e) => {
      console.log(e);
    });
}

onCallConfirmWindowAddTeam(){
  this.setState({AddVendorGroupDisplay2: "block", ConfirmDisplayAddTeam:"none"})
}

onCallConfirmWindowAddVendor(){
  this.setState({ConfirmDisplayAddVendor: "none"})
}

setCompanyTeamGroupAdd (event){
  this.state.companyIDTeamGroupAdd = event.target.value;
  const filterOperatordataAdd = JSON.parse(
    localStorage.getItem("operator")
  ).filter((data) => {
    return data.company_id == event.target.value;
  });

  this.setState({
    operatorIDAdd: 0,
    operatorAdd: filterOperatordataAdd,
    projectIDAdd: 0,
    projectDataAdd: [],
    categoryDataList: [],
    TeamGroupTypeDataList: [],
    jobCategoryIDAdd: 0,
    teamGroupTypeIDAdd: 0
  })

}

closeWindowsAddTeam () {
  this.setState({AddVendorGroupDisplay2: "none"});
  // clear parameter
  this.setState({
    vendorCodeAdd: "",
    vendorNameAdd: "",
    vendorAddressAdd: "",
    telephoneAdd: "",
    faxNoAdd: "",
    contactNameAdd: "",
    EffectiveDateVendorAdd: moment().toDate(),
    EffectiveDateVendorAddFilter: moment().toDate(),
    ExpiryDateVendorAdd: moment().toDate(),
    statusVendorAdd: 1,

    EffectiveDateAdd: moment().toDate(),
    ExpiryDateAdd: moment().toDate(),
    statusAdd: 1,

    emailAdd: "",
    VendorAreaSelectDataListInsert:[],
    VendorTeamGroupDataList:[]
    })
    this.onCloseAddNewWindow();
    this.loadVendor();
}

onSearch = () => {
  this.loadVendor();
}

setVendorType = (e) =>{
  this.setState({vendorTypeAdd:e.target.value});
}

render() {
  const locale = Cookies.get("locale");
  const columns =  [

    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["vendorCode"] : `Vendor Code`,
      selector: 'vendorCode',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["vendorName"] : 'Vendor Name',
      selector: 'vendorName',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["vendorAddress"] : 'Vendor Address',
      selector: 'vendorAddress',
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["serviceCode"] : 'Service Code',
      selector: 'serviceCode',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date',
      selector: 'effectiveDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date',
      selector: 'expiredDate',
      sortable: true,
    },
    {
      name: (this.state.factUpdate)? this.state.LangTranslate[locale]["Action"] :'Action',
      selector: 'Option',
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      style: 'cursor:pointer'
    },
  ];

        return (
            <div>
                <span className="font-mont-r fs-12">Basic Data</span>
                <h3 className="font-mont-sb fs-18 c-blue">{this.state.title}</h3>
                <div className="w-100 box-search m-0">
                  <div className="row">
                      <div className="col-sm-3 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["company"] : `Company`}</div>
                        <div><select
                          placeholder="Please select Company"
                          className="companyid dropdrowtype input-text-add-problem-type form-select"
                          onChange={(e)=>this.setCompany(e)}
                          value={this.state.companyID}
                          required
                        >
                          <option value="" className="please-select">PLEASE SELECT COMPANY</option>
                          {
                          this.state.companyDataList.map((item, index) => (
                            <option value={item.company_id} key={`layout_b_${index}`}>
                            {item.company_name}
                            </option>
                          ))}
                        </select>
                        </div>
                      </div>
                      <div className="col-sm-4 m-0" style={{verticalAlign:"text-top",paddingTop:"25px"}}>
                        <div className="box-search m-0">
                          <Input
                            onChange={(e)=>this.setSearchText(e)}
                            placeholder="Search Vendor Name"
                            style={{ width: 200 }}
                          />
                          <img type="button" src={butSearch} onClick={this.onSearch} className="but-search"/>
                        </div>

                      </div>
                      <div className="col-sm-5 m-0" style={{textAlign: "right",paddingTop:"25px"}}>
                          <button className="but-add-problem-type" onClick={()=>this.onAddVendorGroup()}>Add {this.state.title}</button>
                      </div>
                  </div>
                </div>

                <div className="box-content">
                    {/** load data */}
                    <DataTable
                      style={{fontSize:"20px"}}
                      columns={columns}
                      data={this.state.filterDataList}
                      pagination
                      highlightOnHover
                      progressPending={this.state.isLoadingVendor}
                      persistTableHead={false}
                    />
                </div>

                <form onSubmit={(e)=>this.ClickAction1(e)}>
                  <div id="AddVendorGroupWindow" className="add-new-window" style={{
                          position: 'absolute', top: '20%',
                          left: '50%',
                          marginLeft: '-260px',
                          display: this.state.AddVendorGroupDisplay1

                      }}>
                    <div className="header-add-problem-type-window">{this.state.actionCase} {this.state.title}</div>
                    <div className="header-add-problem-type-window">Step 1 of 2</div>
                    {/* row1 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["company"] : `Company`}</div>
                        <div><select
                          placeholder="Please select Company"
                          className="dropdrowtype input-text-add-problem-type form-select"
                          onChange={(e)=>this.setCompanyAdd(e)}
                          value={this.state.companyIDAdd}
                          required
                        >
                          <option value="" className="please-select">PLEASE SELECT COMPANY</option>
                          {
                          this.state.companyDataList.map((item, index) => (
                            <option value={item.company_id} key={`layout_b_${index}`}>
                            {item.company_name}
                            </option>
                          ))}
                        </select>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["vendorType"] : `Vendor Type`}</div>
                        <div><select
                          placeholder="Please select type"
                          className="dropdrowtype input-text-add-problem-type form-select"
                          onChange={(e)=>this.setVendorType(e)}
                          value={this.state.vendorTypeAdd}
                          required
                        >
                          <option value="" className="please-select">PLEASE SELECT TYPE</option>
                          <option value="0">บุคคลธรรมดา</option>
                          <option value="1">นิติบุคคล</option>
                        </select>
                        </div>
                      </div>

                    </div>
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["vendorCode"] : `Vendor Code`}</div>
                        <div>
                        <input id="vendorCodeAdd" maxLength="20" onChange={(e)=>this.setVendorCodeAdd(e)} value={this.state.vendorCodeAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["vendorName"] : `Vendor Name`}</div>
                        <div>
                        <input id="vendorNameAdd" maxLength="100" onChange={(e)=>this.setVendorNameAdd(e)} value={this.state.vendorNameAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                    </div>

                    {/* row2 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                      <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["vendorAddress"] : `Vendor Address`}</div>
                        <div>
                        <input style={{width: "96%"}} maxLength="100" onChange={(e)=>this.setVendorAddressAdd(e)} value={this.state.vendorAddressAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                    </div>
                    {/* row3 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["contactName"] : `Contact Name`}</div>
                        <div>
                          <input id="ContactNameAdd" maxLength="50" style={{width:"210px"}} onChange={(e)=>this.setContactNameAdd(e)} value={this.state.contactNameAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["contactEmail"] : `Contact Email`}</div>
                        <div>
                          <input style={{width:"210px"}} maxLength="100" onChange={this.setEmailAdd} value={this.state.emailAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                    </div>
                    {/* row6 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["telephone"] : 'Telephone'}</div>
                        <div>
                          <input style={{width:"210px"}} maxLength="20" onChange={(e)=>this.setTelephoneAdd(e)} value={this.state.telephoneAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["FaxNo"] : 'Fax No.'}</div>
                        <div>
                        <input style={{width:"210px"}} maxLength="20" onChange={(e)=>this.setFaxNoAdd(e)} value={this.state.faxNoAdd} className="input-text-add-problem-type" required></input>
                        </div>
                      </div>
                    </div>
                    {/* row7 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 d-flex">
                        <div>
                        <i className="data-important">*</i>Operator<br></br>
                        <select
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setOperatorRowAdd(e)}
                            value={this.state.operatorIDRowAdd}
                            style={{width:"154px"}}
                          >
                            <option value="" className="please-select"></option>
                            {this.state.operatorDataRowAdd.map((item, index) => (
                              <option
                                value={item.operator_id}
                                key={`layoutoption_${index}`}
                              >
                                {item.operator_name}
                              </option>
                            ))}
                            </select>
                        </div>
                        <div className="pl-1">
                        <i className="data-important">*</i>Project<br></br>
                        <select
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setProjectRowDataAdd(e)}
                            value={this.state.projectIDRowAdd}
                            style={{width:"154px"}}
                          >
                          <option value="" className="please-select"></option>
                          {this.state.projectDataRowAdd.map((item, index) => (
                            <option value={item.project_id} key={`layout_b_${index}`}>
                              {item.project_name}
                            </option>
                          ))}
                        </select>
                        </div>
                        <div className="pl-1">
                        <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["areaName"] : 'Area Name'}<br></br>
                          <select
                            className="dropdrowtype input-text-add-problem-type form-select mr-1"
                            onChange={(e)=>this.setAreaRowAdd(this.state.companyIDAdd,e)}
                            value={this.state.vendorAreaIDRowAdd+'_'+this.state.vendorAreaNameRowAdd}
                            style={{width:"154px"}}
                          >
                            <option value="" className="please-select"></option>
                            {
                            this.state.areaDataList.map((item, index) => (

                              <option value={item.job_area_id+'_'+item.job_area_code} key={`layout_b_${index}`}>
                              {item.job_area_code}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    {/* row8 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 d-flex">

                        <div>
                        <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["subAreaName"] : 'Sub Area Name'}<br></br>
                          <select
                            className="dropdrowtype input-text-add-problem-type form-select mr-1"
                            onChange={(e)=>this.setVendorSubAreaRowAdd(e)}
                            value={this.state.vendorSubAreaIDRowAdd+'_'+this.state.vendorSubAreaNameRowAdd}
                            style={{width:"130px"}}
                          >
                            <option value="" className="please-select"></option>
                            {
                            this.state.subAreaDataList.map((item, index) => (

                              <option value={item.sub_area_id+'_'+item.job_sub_area_code} key={`layout_b_${index}`}>
                              {item.job_sub_area_code}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                        <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["zoneName"] : 'Zone Name'}<br></br>
                          <select
                            className="dropdrowtype input-text-add-problem-type form-select mr-1"
                            onChange={(e)=>this.setVendorZoneRowAdd(e)}
                            value={this.state.vendorZoneIDRowAdd+'_'+this.state.vendorZoneNameRowAdd}
                            style={{width:"130px"}}
                          >
                            <option value="" className="please-select"></option>
                            {
                            this.state.vendorZoneDataList.map((item, index) => (
                              <option value={item.team_zone_id+'_'+item.team_zone_name} key={`layout_b_${index}`}>
                              {item.team_zone_name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <br></br>
                          {(this.state.actionCase == "Edit")?(
                          <Button type="primary" onClick={()=>this.onAddEditAreaRow(this.state.rowID)}>&nbsp;&nbsp;Add&nbsp;&nbsp;</Button>
                          ) : (<Button type="primary" onClick={()=>this.onAddAreaRow(this.state.rowID)}>&nbsp;&nbsp;Add&nbsp;&nbsp;</Button>)}
                        </div>

                      </div>
                    </div>
                    {/* row9 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 d-flex pb-2 border-bottom">
                        <div className="col-sm-3">
                          Area
                        </div>
                        <div className="col-sm-3">
                          Sub Area
                        </div>
                        <div className="col-sm-3">
                          Zone
                        </div>
                        <div className="col-sm-3">
                        </div>
                      </div>
                      <div id="vendorArea" className="row row-vendor-area" style={{width: "100%"}}>
                        {(this.state.actionCase == "Edit")? (
                          <div className="col-sm-12 list-area">
                          {
                            (this.state.VendorAreaSelectDataListEdit.length>0) ?
                              (this.state.VendorAreaSelectDataListEdit.map((item,index) => {
                                if(item.area_id!=null){
                                  return (<div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"5px"}} key={index}>
                                  <div style={{width:"120px"}}>
                                  <input type='Checkbox' onChange={(e)=>this.setAreaEdit(item.area_id+'_'+item.sub_area_id+'_'+item.zone_id,e)} /> <span>{item.area_code}</span></div>
                                  <div style={{width:"120px"}}>{item.sub_area_code}</div>
                                  <div style={{width:"120px"}}>{item.zone_code}</div>
                                  <div style={{width:"120px"}}>{(item.delete_flag==null)?null:<span className="txt-remove">remove</span>}</div>
                                </div>)
                                }}
                              ))
                            : null
                          }
                          </div>
                        ):null}
                        <div className="col-sm-12">
                          <div style={{width:"100%",display:this.state.displayVendor0,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-0"} >
                          {this.state.vendorArea0}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor1,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-1"} >
                          {this.state.vendorArea1}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor2,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-2"} >
                          {this.state.vendorArea2}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor3,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-3"} >
                          {this.state.vendorArea3}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor4,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-4"}>
                          {this.state.vendorArea4}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor5,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-5"}>
                          {this.state.vendorArea5}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor6,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-6"}>
                          {this.state.vendorArea6}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor7,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-7"}>
                          {this.state.vendorArea7}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor8,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-8"}>
                          {this.state.vendorArea8}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor9,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-9"}>
                          {this.state.vendorArea9}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor10,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-10"}>
                          {this.state.vendorArea10}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor11,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-11"}>
                          {this.state.vendorArea11}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor12,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-12"}>
                          {this.state.vendorArea12}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor13,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-13"}>
                          {this.state.vendorArea13}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor14,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-14"}>
                          {this.state.vendorArea14}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor15,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-15"}>
                          {this.state.vendorArea15}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor16,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-16"}>
                          {this.state.vendorArea16}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor17,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-17"}>
                          {this.state.vendorArea17}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor18,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-18"}>
                          {this.state.vendorArea18}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor19,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-19"}>
                          {this.state.vendorArea19}
                          </div>
                          <div style={{width:"100%",display:this.state.displayVendor20,paddingTop: "15px", paddingLeft: "5px"}} className={"row-vendor-area-20"}>
                          {this.state.vendorArea20}
                          </div>
                        </div>
                        {(this.state.actionCase == "Edit")?
                        <div className="pt-2">
                          <u>หมายเหตุ:</u> วิธีเอา area ออก
                          <br />
                          <img src={notiArea}></img>
                        </div>
                        : null
                        }
                      </div>
                    </div>
                    {/* row10 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : `Status`}</div>
                      </div>
                      <div className="col-sm-12 p-0">
                      <Radio.Group
                        value={this.state.statusVendorAdd}
                        onChange={(e)=>this.setStatusVendor(e)}
                      >
                        <Radio value={1}>Active</Radio>
                        <Radio value={0}>Inactive</Radio>
                      </Radio.Group>
                      </div>
                    </div>
                    {/* row11 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeEffectiveDateVendor} value={(this.state.EffectiveDateVendorAdd != '')? moment(this.state.EffectiveDateVendorAdd, this.state.dateFormat):""} format={this.state.dateFormat}/>
                        <div style={{display: this.state.fillEffectiveDateDisplay, position: "absolute",color:"#FF0000"}}>Please fill effective date</div>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeExpiryDateVendor}  value={(this.state.ExpiryDateVendorAdd != '')? moment(this.state.ExpiryDateVendorAdd, this.state.dateFormat):""} format={this.state.dateFormat} disabledDate={d => !d || d.isAfter(moment().add(100,"years")) || d.isSameOrBefore(this.state.EffectiveDateVendorAddFilter)}/></div>
                      </div>
                    </div>
                    {/* row12 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                        <Button onClick={this.onCloseAddNewWindow}>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</Button>&nbsp;
                        <input type="submit" className="btn btn-primary-active" value="   Next   " />
                      </div>
                    </div>
                  </div>
                </form>

                <form onSubmit={(e)=>this.ClickAction2(e)}>
                  <div className="add-new-window"  style={{
                    position: 'absolute', top: '20%',
                    left: '50%',
                    marginLeft: '-320px',
                    display: this.state.AddVendorGroupDisplay2,
                    width: '640px'}}>
                    <div>
                      <div className="header-add-problem-type-window">{this.state.actionCase} {this.state.title}</div>
                      <div className="header-add-problem-type-window">Step 2 of 2</div>
                      {/* row1 */}
                      <div className="row row-add">
                        <div className="col-sm-12 m-0 p-0 pt-3 d-flex">
                          <div>
                          <i className="data-important">*</i>Operator<br></br>
                          <select
                              className="dropdrowtype input-text-add-problem-type form-select"
                              onChange={(e)=>this.setOperatorRowAdd(e)}
                              value={this.state.operatorIDRowAdd}
                              style={{width:"154px"}}
                            >
                              <option value="" className="please-select"></option>
                              {this.state.operatorDataRowAdd.map((item, index) => (
                                <option
                                  value={item.operator_id}
                                  key={`layoutoption_${index}`}
                                >
                                  {item.operator_name}
                                </option>
                              ))}
                              </select>
                          </div>
                          <div className="pl-1">
                          <i className="data-important">*</i>Project<br></br>
                          <select
                              className="dropdrowtype input-text-add-problem-type form-select"
                              onChange={(e)=>this.setProjectRowDataAdd(e)}
                              value={this.state.projectIDRowAdd}
                              style={{width:"154px"}}
                            >
                            <option value="" className="please-select"></option>
                            {this.state.projectDataRowAdd.map((item, index) => (
                              <option value={item.project_id} key={`layout_b_${index}`}>
                                {item.project_name}
                              </option>
                            ))}
                          </select>
                          </div>
                          <div className="pl-1 w-100">
                            <div className="box-search m-0">
                            <br></br><Input
                                onChange={(e)=>this.setSearchTextTeam(e)}
                                placeholder="Team Group Name"
                                style={{ width: "130px" }}
                                value={this.state.whereTeam}
                              />
                              <img type="button" src={butSearch} onClick={(e)=>this.loadTeamGroup(e)} className="but-search"/>
                            </div>
                            <div className="pl-1" style={{float: "right"}}><input type="button" className="but-add-team" onClick={()=>this.displayPage3()} value="   Add Team   " /></div>
                          </div>

                        </div>
                      </div>

                      {/* row2 */}
                      <div className="row row-add">
                        <div className="col-sm-12 m-0 p-0 pt-3 pb-2 d-flex border-bottom">
                          <div className="col-sm-3">
                            Team Group Type
                          </div>
                          <div className="col-sm-3">
                            Team Group Name
                          </div>
                          <div className="col-sm-3">
                            Job Category
                          </div>
                          <div className="col-sm-3">
                            Status
                          </div>
                        </div>
                        <div className="col-sm-12 m-0 p-0 pt-3 pb-2 d-flex">
                        {
                          this.state.TeamGroupDataList.map( (item,index) => (
                            <div style={{width:"100%",display:"flex",padding:"0px",maring:"0px",paddingLeft:"15px"}} key={index}>
                              <div style={{width:"150px"}}><Checkbox onChange={(e)=>this.setTeamGroup(e,item.team_group_id,item.group_type_id)}>{item.group_type_name}</Checkbox></div>
                              <div style={{width:"150px"}}>{item.team_group_name}</div>
                              <div style={{width:"150px"}}>{item.job_category_name}</div>
                              <div style={{width:"150px"}} className={"col-sm-3 txt-active-status"+item.is_active}>{this.state.statusActive[item.is_active]}</div>
                            </div>
                          ))
                        }

                        </div>
                      </div>

                      {/* row3 */}
                      <div className="row row-add">
                        <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                          <button type="submit" className="btn btn-primary-active" >&nbsp;&nbsp;&nbsp;CONFIRM&nbsp;&nbsp;&nbsp;</button>&nbsp;<Button onClick={()=>this.closeWindowsAddTeam()}>CLOSE</Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <form onSubmit={(e)=>this.ClickAction3(e)}>
                  <div className="add-new-window"  style={{
                    position: 'absolute', top: '20%',
                    left: '50%',
                    marginLeft: '-320px',
                    display: this.state.AddVendorGroupDisplay3,
                    width: '640px'}}>

                    <div style={{top:"0px", overflow: "hidden", padding: "15px", display: "contents"}}>

                      <div className="header-add-problem-type-window">Create Team Group</div>
                      {/* row1 */}
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["company"] : `Company`}</div>
                        <div><select
                          placeholder="Please select Company"
                          className="companyid dropdrowtype input-text-add-problem-type form-select"
                          onChange={(e)=>this.setCompanyTeamGroupAdd(e)}
                          value={this.state.companyIDTeamGroupAdd}
                          /*required*/
                        >
                          <option value="" className="please-select">PLEASE SELECT COMPANY</option>
                          {
                          this.state.companyDataList.map((item, index) => (
                            <option value={item.company_id} key={`layout_b_${index}`}>
                            {item.company_name}
                            </option>
                          ))}
                        </select>
                        </div>
                    </div>

                    {/* row2 */}
                      <div className="row row-add">
                        <div className="col-sm-12 m-0 p-0 pt-3 d-flex">
                          <div className="col-sm-4">
                            <i className="data-important">*</i>Operator<br></br>
                            <select
                            placeholder="Please select Operator"
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setOperatorAdd(e)}
                            value={this.state.operatorIDAdd}
                            style={{width:"150px"}}
                            //disabled={(this.state.disableChangeValue)? "disabled":false}
                            required
                          >
                            <option value="" className="please-select">PLEASE SELECT OPERATOR</option>
                            {this.state.operatorAdd.map((item, index) => (
                              <option
                                value={item.operator_id}
                                key={`layoutoption_${index}`}
                              >
                                {item.operator_name}
                              </option>
                            ))}
                            </select>
                          </div>
                          <div className="col-sm-4">
                            <i className="data-important">*</i>Project<br></br>
                            <select
                                  id="ProjectAdd"
                                  placeholder="Please select Project"
                                  className="dropdrowtype input-text-add-problem-type form-select"
                                  onChange={(e)=>this.setProjectDataAdd(e)}
                                  value={this.state.projectIDAdd}
                                  style={{width:"150px"}}
                                  required
                                >
                                <option value="" className="please-select">PLEASE SELECT PROJECT</option>
                                {this.state.projectDataAdd.map((item, index) => (
                                  <option value={item.project_id} key={`layout_b_${index}`}>
                                    {item.project_name}
                                  </option>
                                ))}
                              </select>
                          </div>
                          <div className="col-sm-4">
                            <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["jobCategory"] : 'Job Category'}<br></br>
                            <select
                              className="dropdrowtype input-text-add-problem-type form-select mr-1"
                              onChange={(e)=>this.setJobCategoryAdd(e)}
                              value={this.state.jobCategoryIDAdd}
                              style={{width:"150px"}}
                              required
                            >
                              <option value="" className="please-select"></option>
                              {
                              this.state.categoryDataList.map((item, index) => (
                                <option value={item.job_category_id} key={`layout_b_${index}`}>
                                {item.job_category_name}
                                </option>
                              ))}
                            </select>
                          </div>

                        </div>
                      </div>
                      {/* row3 */}
                      <div className="row row-add">
                        <div className="col-sm-12 m-0 p-0 pt-3 d-flex">
                          <div>
                          <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["teamGroupType"] : 'Team Group Type'}
                          </div>
                          <div style={{right:"10px",position:"absolute"}}>
                            <select
                            className="dropdrowtype input-text-add-problem-type form-select"
                            onChange={(e)=>this.setTeamGroupType(e)}
                            value={this.state.teamGroupTypeIDAdd}
                            style={{width:"450px"}}
                            required
                          >
                            <option value="" className="please-select"></option>
                            {this.state.TeamGroupTypeDataList.map((item, index) => (
                              <option
                                value={item.group_type_id}
                                key={`layoutoption_${index}`}
                              >
                                {item.group_type_name}
                              </option>
                            ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      {/* row4 */}
                      <div className="row row-add">
                        <div className="col-sm-12 m-0 p-0 pt-3 d-flex">
                          <div>
                          <i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["teamGroupName"] : 'Team Group Name'}
                          </div>
                          <div style={{right:"10px",position:"absolute"}}>
                            <input style={{width:"450px"}} maxLength="200" onChange={(e)=>this.setTeamGroupName(e)} value={this.state.teamGroupNameAdd} className="input-text-add-problem-type" required></input>
                          </div>
                        </div>
                      </div>
                      {/* row5 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["status"] : `Status`}</div>
                      </div>
                      <div className="col-sm-12 p-0">
                      <Radio.Group
                        id="statusAdd"
                        name="statusAdd"
                        value={this.state.statusAdd}
                        onChange={(e)=>this.setStatus(e)}
                      >
                        <Radio value={1}>Active</Radio>
                        <Radio value={0}>Inactive</Radio>
                      </Radio.Group>
                      </div>
                    </div>
                    {/* row6 */}
                    <div className="row row-add">
                      <div className="col-sm-6 m-0 p-0">
                        <div className="title-add"><i className="data-important">*</i>{(this.state.factUpdate)? this.state.LangTranslate[locale]["EffectiveDate"] : 'Effective Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeEffectiveDate} value={(this.state.EffectiveDateAdd != '')? moment(this.state.EffectiveDateAdd, this.state.dateFormat):""} format={this.state.dateFormat}/>
                        <div style={{display: this.state.fillEffectiveDateDisplay, position: "absolute",color:"#FF0000"}}>Please fill effective date</div>
                        </div>
                      </div>
                      <div className="col-sm-6 m-0 p-0 pl-3">
                        <div className="title-add">{(this.state.factUpdate)? this.state.LangTranslate[locale]["ExpiredDate"] : 'Expired Date'}</div>
                        <div><DatePicker style={{padding: 8}} onChange={this.onChangeExpiryDate}  value={(this.state.ExpiryDateAdd != '')? moment(this.state.ExpiryDateAdd, this.state.dateFormat):""} format={this.state.dateFormat} disabledDate={d => !d || d.isAfter(moment().add(100,"years")) || d.isSameOrBefore(this.state.EffectiveDateAddFilter)}/></div>
                      </div>
                    </div>
                    {/* row7 */}
                    <div className="row row-add">
                      <div className="col-sm-12 m-0 p-0 pt-3 text-center">
                        <Button onClick={()=>this.onCloseAddNewTeamWindow()}>&nbsp;&nbsp;Cancel&nbsp;&nbsp;</Button>&nbsp;<button type="submit" className="btn btn-primary-active" >&nbsp;&nbsp;&nbsp;COMFIRM&nbsp;&nbsp;&nbsp;</button>
                      </div>
                    </div>

                    </div>
                  </div>

                </form>

                <div id="ConfirmWindow" className="confirm-window" style={{
                          position: 'absolute', left: '50%', top: '20%',
                          transform: 'translate(-50%, -20%)',
                          display: this.state.ConfirmDisplay
                      }}>
                  <div className="row">
                    <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
                      {this.state.resultAddNewText}
                    </div>
                  </div>
                  <div className="row row-add">
                    <div className="col-sm-12 m-0 p-0 text-center">
                      <Button type="primary" onClick={()=>this.onCallConfirmWindow()}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>                      
                    </div>
                  </div>
                </div>

                <div id="ConfirmWindowAddTeam" className="confirm-window" style={{
                          position: 'absolute', left: '50%', top: '20%',
                          transform: 'translate(-50%, -20%)',
                          display: this.state.ConfirmDisplayAddTeam
                      }}>
                  <div className="row">
                    <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
                      {this.state.resultAddNewText}
                    </div>
                  </div>
                  <div className="row row-add">
                    <div className="col-sm-12 m-0 p-0 text-center">
                      <Button type="primary" onClick={()=>this.onCallConfirmWindowAddTeam()}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>                      
                    </div>
                  </div>
                </div>

                <div id="ConfirmWindowAddVendor" className="confirm-window" style={{
                          position: 'absolute', left: '50%', top: '20%',
                          transform: 'translate(-50%, -20%)',
                          display: this.state.ConfirmDisplayAddVendor
                      }}>
                  <div className="row">
                    <div className="col-sm-12 m-0 p-3 text-center txt-confirm">
                      {this.state.resultAddNewText}
                    </div>
                  </div>
                  <div className="row row-add">
                    <div className="col-sm-12 m-0 p-0 text-center">
                      <Button type="primary" onClick={()=>this.onCallConfirmWindowAddVendor()}>&nbsp;&nbsp;ปิด&nbsp;&nbsp;</Button>                      
                    </div>
                  </div>
                </div>

            </div>
        );
    }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};
export default connect(mapStateToProps, mapDispacthToProps)(vendorGroup);

